import React, { Component } from 'react';
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import { bindActionCreators } from 'redux';

import { Button } from '../../components/Button';
import { ModalComponent } from '../../components/Modal';
import { UserEdit } from '../../components/UserEdit';

import { adminCreateUser } from '../../actions/users';

class AdminNavigation extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);

    this.state = {
      modalOpen: false,
    };
  }

  handleSubmit(user) { // eslint-disable-line
    if (user.password.length < 6) {
      Alert.warning('Password to short, min 6 chars', {timeout: 2000});
      return null;
    }

    this.props.adminCreateUser({
      username: user.username,
      admin: user.admin || false,
      email: user.email,
      password: user.password,
      company: this.props.user.company,
    });
    this.handleModalClose();
  }

  handleModalOpen() {
    this.setState({modalOpen: true});
  }

  handleModalClose() {
    this.setState({modalOpen: false});
  }

  render() {
    const { user } = this.props;
    const { modalOpen } = this.state;

    return (
      <div style={{padding: '10px'}}>
        <h2>
          Welcome&nbsp;
          {user.username}
        </h2>
        <Button
          block
          onClick={this.handleModalOpen}
        >
          ADD USER
        </Button>
        <ModalComponent
          handleHide={this.handleModalClose}
          open={modalOpen}
          title="CREATE NEW USER"
        >
          <h3>
            Edit user:
          </h3>
          <UserEdit
            new
            onDelete={() => null} // eslint-disable-line
            onSubmit={this.handleSubmit}
            user={{}}
          />
        </ModalComponent>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    adminCreateUser,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminNavigation);



// WEBPACK FOOTER //
// ./src/containers/Admin/navigation.js